module.exports = __webpack_public_path__ + "static/overview-pc-a39e3fb3a5b9b51883ee85879e8c5713.png";